import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { withTranslation } from 'react-i18next';
import SelectedItemsPanel from '../SelectedItemsPanel';
import GroupOperationButton from '../GroupOperationButton';
import GallectionListMenu from '../GallectionListMenu';
import { areGallectionContentsManageable, getFolderIdsDisabledForDeviationCopy, } from '../../helpers';
import { copyDeviations, moveDeviations, removeDeviations, } from '../../actions';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import withGallections from '../../_hocs/withGallections';
import withCurrentTier from '../../_hocs/withCurrentTier';
import manageableSelectedItemsPanelStyles from './ManageableSelectedItemsPanel.scss';
var enhance = compose(withGallections, withCurrentGallection, withCurrentSubfolder, withCurrentTier, withSelectedDeviations, connectMediaStore(null, {
    copyDeviations: copyDeviations,
    moveDeviations: moveDeviations,
    removeDeviations: removeDeviations,
}), withTranslation());
export var ManageableSelectedItemsPanel = function (_a) {
    var t = _a.t, gallections = _a.gallections, currentTopLevelGallection = _a.currentGallection, currentSubfolder = _a.currentSubfolder, currentTierId = _a.currentTierId, selectedDeviations = _a.selectedDeviations, moveDeviationsAction = _a.moveDeviations, copyDeviationsAction = _a.copyDeviations, removeDeviationsAction = _a.removeDeviations;
    var currentGallection = currentSubfolder || currentTopLevelGallection;
    var isCurrentGallectionManageable = currentGallection && areGallectionContentsManageable(currentGallection);
    var isCurrentGallectionPremium = !!(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.premiumFolderData);
    var isTierContent = !!currentTierId;
    var isStash = (currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type) === 'stash';
    var moveToSelectedGallection = function (folderId) {
        moveDeviationsAction({
            deviations: selectedDeviations,
            targetFolderId: folderId,
        });
    };
    var copyToSelectedGallection = function (folderId) {
        copyDeviationsAction({
            deviations: selectedDeviations,
            targetFolderId: folderId,
        });
    };
    var remove = function () {
        removeDeviationsAction(selectedDeviations);
    };
    return (React.createElement(SelectedItemsPanel, { extras: React.createElement("div", null,
            !isTierContent && (React.createElement(GroupOperationButton, { className: manageableSelectedItemsPanelStyles['group-operation-button'], disabled: !isCurrentGallectionManageable },
                t('mediapopup.moveTo'),
                React.createElement("div", { className: manageableSelectedItemsPanelStyles['group-operation-menu-wrapper'] },
                    React.createElement(GallectionListMenu, { onSelect: moveToSelectedGallection })))),
            !isTierContent && !isStash && (React.createElement(GroupOperationButton, { className: manageableSelectedItemsPanelStyles['group-operation-button'], disabled: isCurrentGallectionPremium },
                t('mediapopup.copyTo'),
                React.createElement("div", { className: manageableSelectedItemsPanelStyles['group-operation-menu-wrapper'] },
                    React.createElement(GallectionListMenu, { disableFolderIds: getFolderIdsDisabledForDeviationCopy(gallections, currentTopLevelGallection === null || currentTopLevelGallection === void 0 ? void 0 : currentTopLevelGallection.folderId), onSelect: copyToSelectedGallection })))),
            React.createElement(GroupOperationButton, { onClick: remove, className: classnames(manageableSelectedItemsPanelStyles['group-operation-button'], manageableSelectedItemsPanelStyles['group-remove']), disabled: !isCurrentGallectionManageable && !isTierContent }, t('mediapopup.delete'))) }));
};
ManageableSelectedItemsPanel.displayName = 'ManageableSelectedItemsPanel';
export default enhance(ManageableSelectedItemsPanel);
//# sourceMappingURL=ManageableSelectedItemsPanel.connected.js.map